<script lang="ts">
    import AddressInfo from '../components/AddressInfo.svelte';
    import AdvCookieNotice from '../components/AdvCookieNotice.svelte';
    import ApplyStepForm from '../components/ApplyStepForm.svelte';
    import BenefitInfo from '../components/BenefitInfo.svelte';
    import LoginHeader from '../components/loginHeader.svelte';
    import PhoneModule from '../components/PhoneModule.svelte';
    import QuickDownload from '../components/QuickDownload.svelte';
    import { visible, cookieHeight, isCookiesShow } from '../store/index';

    import { CREDIT_CARD_CAT } from '@/configs/compliance';
    import { DIDI_LOGO_LINE } from '@/configs/images';
</script>

<div
    class="creditcard-page page-regular"
    style={`transition: padding-bottom 0.3s ease; padding-bottom: ${$isCookiesShow ? $cookieHeight : 0}px;`}
>
    {#if $visible}
        <QuickDownload logo={DIDI_LOGO_LINE} />
    {/if}

    <LoginHeader />

    <PhoneModule />
    <BenefitInfo type="fifa" />
    <ApplyStepForm />
    <AddressInfo catText={CREDIT_CARD_CAT.CARD_MSI} />
    <AdvCookieNotice />
</div>

<style lang="scss">
    :global(body) {
        background: #ffffff;
    }

    .creditcard-page {
        margin: auto;
        margin-top: 0;
        width: 7.5rem;
        min-height: 100vh;
        position: relative;
        overflow-x: hidden;
        font-family: DiDiSans-Pro-Regular;
        user-select: none;
        background-color: #ffffff;
        padding: 0;
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
